import type { ReactNode } from 'react';

type AppConfirmDialogTone = 'primary' | 'danger';

type AppConfirmDialogProps = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  tone?: AppConfirmDialogTone;
  onConfirm: () => void;
  onCancel: () => void;
  children?: ReactNode;
};

export default function AppConfirmDialog({
  isOpen,
  title,
  message,
  confirmText = '確定',
  cancelText = 'キャンセル',
  tone = 'primary',
  onConfirm,
  onCancel,
  children,
}: AppConfirmDialogProps) {
  if (!isOpen) return null;

  const confirmClass =
    tone === 'danger'
      ? 'bg-red-600 hover:bg-red-700'
      : 'bg-indigo-600 hover:bg-indigo-700';

  return (
    <div className="fixed inset-0 bg-black/40 z-[400] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-3">{title}</h3>
        <div className="text-gray-600 mb-6 leading-relaxed text-sm">{message}</div>
        {children ? <div className="mb-6">{children}</div> : null}
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-5 py-2.5 text-gray-600 font-bold hover:bg-gray-100 rounded-lg transition-colors text-sm"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-6 py-2.5 text-white font-bold rounded-lg shadow-md transition-all text-sm ${confirmClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
